const normalizeMode = (mode) => (mode === 'create' ? 'register' : mode || 'all');

const visibility = (field = {}) =>
  typeof field.visibilityType === 'string' ? field.visibilityType.toLowerCase() : 'all';

export const isFieldVisibleByMode = (field = {}, mode = 'all') => {
  if (field.active !== true || field.allowVisibility === false) return false;

  const type = visibility(field);
  const normalized = normalizeMode(mode);

  return normalized === 'register'
    ? ['all', 'register', 'create'].includes(type)
    : normalized === 'edit'
      ? ['all', 'edit'].includes(type)
      : true;
};

export const mapFieldsByMode = (fields = [], mode = 'all') =>
  fields.filter((field) => isFieldVisibleByMode(field, mode));

export const mapFormByMode = (form = {}, mode = 'all') => ({
  ...form,
  formFields: mapFieldsByMode(form.formFields || [], mode),
  otherBlocks: Object.fromEntries(
    Object.entries(form.otherBlocks || {}).flatMap(([key, block]) => {
      if (block?.active !== true) return [];

      const fields = mapFieldsByMode(block.fields || [], mode);

      return fields.length ? [[key, { ...block, fields }]] : [];
    })
  ),
});
